import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageModel } from 'src/app/models/Language.model';
import { Storage } from '@ionic/storage';
import { UserService } from '../user/user.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(
    private translate: TranslateService,
    private storage: Storage,
    private userService: UserService,
  ) {}

  languages: LanguageModel[] = [
    {
      name: {
        pt: 'Portugues',
        en: 'Portuguese',
        es: 'Portugués',
        thai: 'โปรตุเกส',
      },
      iso: 'pt',
    },
    {
      name: { pt: 'Inglês', en: 'English', es: 'Inglés', thai: 'สเปน' },
      iso: 'en',
    },
    {
      name: { pt: 'Espanhol', en: 'Spanish', es: 'Español', thai: 'ภาษาอังกฤษ' },
      iso: 'es',
    },
    {
      name: { pt: 'Tailandês', en: 'Thai', es: 'Tailandés', thai: 'แบบไทย' },
      iso: 'thai',
    },
  ];
  language: LanguageModel = {
    name: { pt: 'Portugues', en: 'Portuguese', es: 'Portugués', thai: 'โปรตุเกส' },
    iso: 'pt',
  };

  async setLanguage(iso: string) {
    for (const el of this.languages) {
      if (el.iso === iso) {
        this.language = el;
        this.translate.setDefaultLang(iso);
        await firstValueFrom(this.translate.use(iso));
        await this.storage.set('language', iso);
        break;
      }
    }
  }
}
